'use client';

import { useRef, useState } from 'react';
import { useTranslations } from 'next-intl';
import { CatButton } from 'blocks-nextjs/blocks-react/components/Button';
import { CatDrawer } from 'blocks-nextjs/blocks-react/components/Drawer';
import styles from './availability-by-date-drawer.module.scss';
import { v4 } from 'uuid';
import { availabilityByDateDrawerTypes } from './types';
import AvailabilityByDateContent from './availability-by-date-content';

const AvailabilityByDateDrawer = ({
  availability,
  address
}: availabilityByDateDrawerTypes) => {
  const t = useTranslations();
  const drawerRef = useRef(null);
  const [drawerActive, setDrawerActive] = useState(false);

  return (
    <div className="cat-u-margin-top-md">
      <CatButton
        onClick={() => {
          drawerRef.current?.toggle();
          setDrawerActive(true);
        }}
        variant="ghost"
        className={styles['avail-by-date__btn']}
      >
        {t('AVAIL_STANDARD_AVAILAIBILITY_DATES')}
      </CatButton>
      <CatDrawer
        ref={drawerRef}
        isActive={drawerActive}
        data-testid="availability-by-date-drawer"
      >
        <div slot="header" className="cat-u-theme-typography-title-sm">
          Availability by date
        </div>

        <div className="cat-u-margin-left-sm">
          {availability?.map(
            ({
              availabilityMessage,
              quantityAvailable,
              showContactDealerPopUp
            }) => {
              return (
                <div
                  className="cat-u-margin-bottom-md"
                  key={`avail-by-date-${v4()}`}
                >
                  <AvailabilityByDateContent
                    address={address}
                    message={availabilityMessage}
                    quantityAvailable={quantityAvailable}
                    showContactDealerPopUp={showContactDealerPopUp}
                  />
                </div>
              );
            }
          )}
        </div>
      </CatDrawer>
    </div>
  );
};

export default AvailabilityByDateDrawer;
